export const imageBase =
  "https://images-r2.dev-almanea.com/cdn-cgi/image/fit=contain,quality=75,format=auto";

export const installmentsBy_6_skus = [
  // "139904799465020",
  "170100501025113",
  "170100501025114",
  "170100501025115",
  "170100501025116",
  "170100501030136",
  "170100501030137",
  "170100501030138",
  "170100501030139",
  "170100501030140",
  "170100501030141",
  "170100501030142",
  "170100501030143",
  "170100501035050",
  "170100501035051",
  "170100501035052",
  "170100501035053",
  "170100501030144",
  "170100501030145",
  "170100501030146",
  "170100501030147",
  "170100501035054",
  "170100501035055",
  "170100501035056",
  "170100501035057",
];